import { ApplicationImportance } from '../application-importance'
import { ServerEnvironment } from '../server-environment'
import { BaseAssessRule } from '../assess-rules'
import { RuleSeverity } from '../shared'

export { VulnerabilityPolicyWrappedEditForm } from './policy/wrapped-edit-form'
export { VulnerabilityPolicyWrappedAddForm } from './policy/wrapped-add-form'
export { VulnerabilityPolicyEditForm } from './policy/edit-form'
export { VulnerabilityPoliciesManager } from './vulnerability-policies-manager'
export { VulnerabilityTtrManager } from './vulnerability-ttr-manager'

export type VulnerabilityPolicyAction = 'NOTIFY' | 'AUTO_REMEDIATE'
export type TTRTimeFilterType = 'CLOSED' | 'LAST_SEEN' | 'DISCOVERED'

export const ruleSeveritiesi18nConfig: Record<RuleSeverity, string> = {
  NOTE: 'title_vulnRuleSeverityTypeNote',
  LOW: 'title_vulnRuleSeverityTypeLow',
  MEDIUM: 'title_vulnRuleSeverityTypeMedium',
  HIGH: 'title_vulnRuleSeverityTypeHigh',
  CRITICAL: 'title_vulnRuleSeverityTypeCritical'
}

export const actionEquivalence: Record<string, VulnerabilityPolicyAction> = {
  notify: 'NOTIFY',
  'auto-verification': 'AUTO_REMEDIATE'
}

export enum AutoVerificationType {
  SESSION = 'SESSION',
  ROUTE = 'ROUTE',
  NONE = 'NONE'
}

export interface BaseVulnerabilityPolicy {
  readonly id: string
  readonly name: string
  readonly enabled: boolean
  readonly allRules: boolean
  readonly allApplications: boolean
  readonly serverEnvironments: ServerEnvironment[]
  readonly allServerEnvironments: boolean
  readonly applicationImportance: ApplicationImportance[]
  readonly ruleSeverities: RuleSeverity[]
  readonly remediationDays: number
  readonly valid: boolean
  readonly action: VulnerabilityPolicyAction
  readonly timeBasedEnabled: boolean
  readonly routeBasedEnabled: boolean
  autoVerificationType: AutoVerificationType
}

export interface VulnerabilityPolicy extends BaseVulnerabilityPolicy {
  readonly rules: BaseAssessRule[]
  readonly applications: BaseApplication[]
}

export interface VulnerabilityPolicyInput extends BaseVulnerabilityPolicy {
  readonly rules: string[]
  readonly applications: string[]
}

export interface ApprovalWorkflowSettings {
  readonly workflowEnabled: boolean
  readonly statuses: string[]
  readonly severities: string[]
}

export interface SubstatusAliasSettings {
  readonly aliasEnabled: boolean
  readonly alias: string
}

export function normalizeAction(actionString: string) {
  const action = actionEquivalence[actionString]

  if (!action) {
    throw new Error('Action ' + actionString + ' is undefined')
  }

  return action
}

export interface BaseApplication {
  readonly id: string
  readonly name: string
}

export interface TTRTimeFilterValue {
  id: TTRTimeFilterType
  title: string
}

export const TTRTimeFilterValues: TTRTimeFilterValue[] = [
  { id: 'CLOSED', title: 'title_ttrTimeFilter_closed' },
  { id: 'LAST_SEEN', title: 'title_ttrTimeFilter_lastSeen' },
  { id: 'DISCOVERED', title: 'title_ttrTimeFilter_discovered' }
]
